import React, { useState } from 'react';
import { FaLock } from 'react-icons/fa';
import api from './axiosSetup';

const ChangePasswordForced = () => {
  const [newPassword, setNewPassword] = useState('');
  const [confirm, setConfirm] = useState('');
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    if (newPassword !== confirm) {
      setError('Die Passwörter stimmen nicht überein.');
      return;
    }
    if (newPassword.length < 6) {
      setError('Das Passwort muss mindestens 6 Zeichen lang sein.');
      return;
    }
    setSaving(true);
    try {
      await api.post('/api/change-password-forced', { newPassword });
      // Token ist nach Passwortänderung ungültig (tokenVersion erhöht) → neu einloggen
      localStorage.removeItem('authToken');
      localStorage.removeItem('refreshToken');
      window.location.href = '/login';
    } catch (err) {
      setError(err.response?.data?.message || 'Fehler beim Ändern des Passworts.');
    }
    setSaving(false);
  };

  return (
    <div
      className="d-flex flex-column min-vh-100 justify-content-center align-items-center"
      style={{ background: '#1a1a2e' }}
    >
      <div
        className="bg-dark text-white p-4 rounded shadow-lg w-100"
        style={{ maxWidth: 440 }}
      >
        <div className="text-center mb-4">
          <div
            style={{
              width: 56, height: 56, borderRadius: '14px',
              background: 'rgba(250,204,21,0.12)', border: '1.5px solid rgba(250,204,21,0.35)',
              display: 'inline-flex', alignItems: 'center', justifyContent: 'center',
              fontSize: '1.5rem', marginBottom: '0.75rem',
            }}
          >
            <FaLock style={{ color: '#facc15' }} />
          </div>
          <h4 className="mb-1" style={{ fontWeight: 700 }}>Neues Passwort setzen</h4>
          <p className="text-secondary mb-0" style={{ fontSize: '0.875rem' }}>
            Dein Passwort wurde vom Administrator zurückgesetzt.<br />
            Bitte wähle jetzt ein neues Passwort.
          </p>
        </div>

        {error && <div className="alert alert-danger py-2">{error}</div>}

        <form onSubmit={handleSubmit}>
          <div className="mb-3">
            <label className="form-label">Neues Passwort</label>
            <input
              type="password"
              className="form-control bg-dark text-white border-secondary"
              value={newPassword}
              onChange={e => setNewPassword(e.target.value)}
              required
              minLength={6}
              placeholder="Mindestens 6 Zeichen"
              autoFocus
            />
          </div>
          <div className="mb-4">
            <label className="form-label">Passwort bestätigen</label>
            <input
              type="password"
              className="form-control bg-dark text-white border-secondary"
              value={confirm}
              onChange={e => setConfirm(e.target.value)}
              required
              placeholder="Passwort wiederholen"
            />
          </div>
          <button
            type="submit"
            className="btn btn-warning w-100 fw-semibold"
            disabled={saving}
          >
            {saving ? 'Wird gespeichert…' : 'Passwort ändern & neu anmelden'}
          </button>
        </form>
      </div>
    </div>
  );
};

export default ChangePasswordForced;
